import './verifyPayment.css';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { bookingStatus } from '../../api/bookingAPI';
import { createPortal } from 'react-dom';
import { trackEvent } from '../../utils/analytics';

export default function VerifyPayment() {
    const [showRetry, setShowRetry] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const type = location.state?.type || localStorage.getItem('bookingType') || 'trip';
    // Trip bookings use /trip/review-booking; other types /<type>/review-booking
    const reviewPath = `/${type}/review-booking`;
    // bookingId from URL or fallback from localStorage
    const bookedData = JSON.parse(localStorage.getItem('bookedData'));
    const bookingData = JSON.parse(localStorage.getItem('bookingData1'));

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowRetry(true);
        }, 180000); // 3 minutes = 180000 ms

        return () => clearTimeout(timer); // cleanup on unmount
    }, []);

    useEffect(() => {
        if (bookedData === null) return;
        if (!bookedData?.bookingId) {
            navigate(reviewPath);
            return;
        }

        const checkInterval = 3000; // 3 sec
        const timeoutLimit = 600000; // 10 min

        let intervalId;

        // Timeout → return to review booking
        const timeoutId = setTimeout(() => {
            clearInterval(intervalId);
            navigate(reviewPath);
        }, timeoutLimit);
        // Polling function
        intervalId = setInterval(async () => {
            try {
                const res = await bookingStatus(type, bookedData?.bookingId);

                const paymentState = res?.data?.paymentInfo?.status;
                if (paymentState === 'Paid') {
                    clearInterval(intervalId);
                    clearTimeout(timeoutId);
                    trackEvent({
                        event: 'payment_success',
                        page: window.location.pathname,
                        tripId: bookingData?.packId || null,
                        dateId: bookingData?.packDateId || null,
                        bookingId: bookedData?.bookingId || null,
                        metadata: {
                            amount: bookingData?.amountPaid?.paid || null,
                            paymentType: bookingData?.paymentType || null
                        }
                    });

                    localStorage.setItem(
                        'backendBookingData',
                        JSON.stringify({
                            ...res?.data,
                            // ...(type === 'gu' ? { totalSeats: bookingData.people } : {}),
                            organizerName: bookingData?.organizerName,
                            days: bookingData?.days,
                            convenienceFee: bookingData?.convenienceFee,
                            type: type,
                            roomPrice: bookingData?.roomAmount,
                            vehiclePrice: bookingData?.vehiclePrice
                        })
                    );
                    navigate('/booking-confirmation');
                } else if (paymentState === 'Failed') {
                    clearInterval(intervalId);
                    clearTimeout(timeoutId);
                    trackEvent({
                        event: 'payment_failed',
                        page: window.location.pathname,
                        tripId: bookingData?.packId || null,
                        dateId: bookingData?.packDateId || null,
                        bookingId: bookedData?.bookingId || null,
                        metadata: {
                            amount: bookingData?.amountPaid?.paid || null,
                            paymentType: bookingData?.paymentType || null
                        }
                    });
                    navigate(reviewPath);
                }
            } catch (error) {
                console.error('Polling failed:', error);
            }
        }, checkInterval);

        // Cleanup on component unmount
        return () => {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
        };
        //eslint-disable-next-line
    }, [bookedData?.bookingId, navigate]);

    return createPortal(
        <div className='loadingBackgroundPayment'>
            <ReactLoading type='spin' color='#006aff' className='loadingSpinPayment' />

            <p className='loadingText'>Please wait while we verify your payment…</p>

            {showRetry && (
                <div style={{ marginTop: '30px' }}>
                    <button
                        onClick={() => navigate(reviewPath)}
                        style={{
                            padding: '10px 15px',
                            background: '#006aff',
                            color: 'white',
                            borderRadius: '6px',
                            marginRight: '10px',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        Click to retry payment
                    </button>
                </div>
            )}
        </div>,
        document.body
    );
}
